import type { ComponentProps } from 'react';
import React from 'react';
import styled from '@emotion/styled';
import type { BackgroundColorProps } from 'styled-system';
import { backgroundColor, space } from 'styled-system';

import type { SpaceProps } from '../../theme/system-types';
import type { ResponsiveImageWidths } from '../../types/Image';
import DefaultProductImage from '../DefaultProductImage';

export type FallbackImageStyles = Partial<ComponentProps<typeof DefaultProductImage>>;

interface CarouselFallbackImageProps {
  handleClick?: () => void;
  name: string;
  widths: ResponsiveImageWidths;
  href?: string;
  fallbackImageStyles?: FallbackImageStyles;
}

const Container = styled.div<SpaceProps & BackgroundColorProps>`
  ${backgroundColor};
  ${space};
`;

const containerStyles: ComponentProps<typeof Container> = {
  backgroundColor: 'sys.neutral.background.default',
  mb: 'sp_4',
  p: 'sp_12',
};

const CarouselFallbackImage = ({
  name,
  href,
  handleClick,
  fallbackImageStyles = {},
  widths,
}: CarouselFallbackImageProps) => (
  <Container {...containerStyles}>
    <DefaultProductImage
      {...fallbackImageStyles}
      title={name}
      href={href}
      onClick={() => handleClick}
      size={widths}
    />
  </Container>
);

export default CarouselFallbackImage;
